import type { CollectionBase } from '@/features/events/types';
import {
  type LaunchOption,
  type LaunchParams,
  toLaunchParams,
} from '@/hooks/useLauncher';
import { getExperiencePath } from '../../utils/getExperiencePath';

export const getRedirectLink = (
  isExtension: boolean,
  base: CollectionBase | null,
  launch: LaunchOption | null = null,
  params: LaunchParams = {}
): string => {
  const path = getExperiencePath(isExtension);

  const query = toLaunchParams(params);
  if (base?.chat?.id && base.chat.isSaved) {
    query.c = base.chat.id;
  } else if (base?.job?.id) {
    query.e = base.job.id;
  }
  if (launch) {
    query.launch = launch;
  }

  const queryParams = new URLSearchParams(window.location.search);
  // `code` is the previous attempt's result, stamped on the URL by the auth
  // callback. Copying it forward lands a successful sign-in on the last
  // failure's code; the callback stamps a fresh one either way.
  queryParams.delete('code');
  new URLSearchParams(query).forEach((value, key) =>
    queryParams.set(key, value)
  );

  const queryString = queryParams.toString();
  const search = queryString.length > 0 ? `?${queryString}` : '';

  return `${path}${search}`;
};
